class CartDrawer extends HTMLElement {
  constructor() {
    super()

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close())
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this))
    this.setHeaderCartIconAccessibility()
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble')
    cartLink.setAttribute('role', 'button')
    cartLink.setAttribute('aria-haspopup', 'dialog')
    cartLink.addEventListener('click', (event) => {
      event.preventDefault()
      this.open(cartLink)
    })
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault()
        this.open(cartLink)
      }
    })
  }

  open(triggeredBy) {
    // Don't open if we are in the hybrid-cart group
    // if (window.CART_AB_TEST === "hybrid-cart" || !window.CART_AB_TEST) return;
    if (triggeredBy) this.setActiveElement(triggeredBy)
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary')
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote)
    const overlay = this.querySelector('#CartDrawer-Overlay')
    const splideSamples = this.querySelector('.splide-free-samples')
    if (splideSamples) {
      splideSamples.style.display = 'block'
    }
    setTimeout(() => {
      this.classList.add('animate', 'active')
      if (overlay) {
        overlay.classList.remove('opacity-0')
        overlay.classList.add('opacity-100')
      }
    })

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer')
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close')
        trapFocus(containerToTrapFocusOn, focusElement)

        // Initialize Splide slider on first open
        this.initializeFreeSampleSlider()
      },
      { once: true }
    )

    document.body.classList.add('overflow-hidden')
  }

  close() {
    const overlay = this.querySelector('#CartDrawer-Overlay')
    const splideSamples = this.querySelector('.splide-free-samples')
    if (splideSamples) {
      splideSamples.style.display = 'none'
    }

    if (overlay) {
      overlay.classList.remove('opacity-100')
      overlay.classList.add('opacity-0')
    }

    this.classList.remove('active')
    removeTrapFocus(this.activeElement)
    document.body.classList.remove('overflow-hidden')
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button')
    cartDrawerNote.setAttribute('aria-expanded', 'false')

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id)
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'))
    })

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape)
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty')
    this.productId = parsedState.id

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id)
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector)
    })
    this.initializeFreeSampleSlider()

    setTimeout(() => {
      const overlay = this.querySelector('#CartDrawer-Overlay')
      if (overlay) {
        overlay.addEventListener('click', this.close.bind(this))
      }
      this.open()
    })
  }

  initializeFreeSampleSlider() {
    const freeSampleSplide = this.querySelector('.splide.splide-free-samples')
    if (freeSampleSplide && typeof Splide !== 'undefined') {
      // Destroy existing instance if it exists
      if (freeSampleSplide.splide) {
        freeSampleSplide.splide.destroy(true)
      }

      const slider = new Splide(freeSampleSplide, {
        type: 'slide',
        perPage: 3,
        perMove: 1,
        gap: '1rem',
        pagination: false,
        arrows: false,
      }).mount()

      if (typeof SplideHorizontalScroll !== 'undefined') {
        SplideHorizontalScroll(slider)
      }
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ]
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)
  }

  setActiveElement(element) {
    this.activeElement = element
  }
}

customElements.define('cart-drawer', CartDrawer)

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ]
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`)
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state)
        const html = new DOMParser().parseFromString(state, 'text/html')
        const cartTotal = html.querySelector('[data-total-price').dataset
        const splitPrice = cartTotal.totalPrice.split('"')[1]
        const finalPrice = splitPrice.replace(/\\/g, '')
        const siteWideSaleTierOneItems = document.querySelectorAll('[data-site-wide-sale-tier-one]')
        const siteWideSaleTierTwoItems = document.querySelectorAll('[data-site-wide-sale-tier-two]')
        const skioPrice = document.querySelector('.product__info-container.product__column-sticky .skio-price')
        if (parseInt(finalPrice) >= 5000) {
          siteWideSaleTierOneItems.forEach((item) => {
            item.style.display = 'none'
            item.removeAttribute('selected')
          })
          siteWideSaleTierTwoItems.forEach((item) => {
            if (!skioPrice || skioPrice.style.display !== 'inline') {
              item.style.display = 'inline-block'
            }
            item.setAttribute('selected', true)
          })
        } else {
          siteWideSaleTierOneItems.forEach((item) => {
            if (!skioPrice || skioPrice.style.display !== 'inline') {
              item.style.display = 'inline-block'
            }
            item.setAttribute('selected', true)
          })
          siteWideSaleTierTwoItems.forEach((item) => {
            item.style.display = 'none'
            item.removeAttribute('selected')
          })
        }
        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id)

          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector)
        })

        const cartDrawer = document.querySelector('cart-drawer')
        if (cartDrawer && cartDrawer.initializeFreeSampleSlider) {
          cartDrawer.initializeFreeSampleSlider()
        }
      })
      .catch((e) => {
        console.error(e)
      })
  }
}

customElements.define('cart-drawer-items', CartDrawerItems)
